export default __webpack_public_path__ + "static/media/prenatalLandingPageBanner2.464688ec.jpg";